import { render, staticRenderFns } from "./member-costs.vue?vue&type=template&id=48da4862&scoped=true"
import script from "./member-costs.vue?vue&type=script&lang=js"
export * from "./member-costs.vue?vue&type=script&lang=js"
import style0 from "./member-costs.vue?vue&type=style&index=0&id=48da4862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48da4862",
  null
  
)

export default component.exports